const languages = [
  {
    lang: 'en',
    name: 'Eng',
    direction: 'ltr'
  },
  {
    lang: 'ar',
    name: 'العربية',
    direction: 'rtl'
  }
];

export const Languages = {
  Arabic: 'ar',
  English: 'en',
}

export default languages;
